<template>
  <section class="booking">
    <h2>Booking de Informações</h2>

    <div class="booking__tab">
      <button
        class="booking__tablinks"
        @click="openBook($event, 'manualUsuario')"
      >
        <i class="fas fa-book-open"></i>
        <span>Manual do Usuário</span>
      </button>

      <div class="booking__tabcontent" id="manualUsuario">
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/1-MANUAL%20USUARIO%20MAP-Cadastro%20Pessoa%20Fisica%20e%20Juridica.pdf"
            ><i class="fas fa-angle-double-right"></i> Cadastro de PF E PJ</a
          >
        </p>
        <p>
          <a href="https://www.leverosintegra.com.br/Blog/Post.aspx?Post=5"
            ><i class="fas fa-angle-double-right"></i> Como Criar Pedido no
            MAP</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/COM-PI02%20-%20Cadastro%20e%20Pedido%20de%20venda%20PJ_final.pdf"
            ><i class="fas fa-angle-double-right"></i> Regras Fiscais</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/Treinamento%20Processos%20e%20erros%20(1).pdf"
            ><i class="fas fa-angle-double-right"></i> Cadastros PJ e regras
            fiscais</a
          >
        </p>
      </div>

      <button class="booking__tablinks" @click="openBook($event, 'vendas')">
        <i class="fas fa-shopping-cart"></i>
        <span>Vendas</span>
      </button>

      <div class="booking__tabcontent" id="vendas">
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/1-VENDA%20%C3%80%20ORDEM%20Opera%C3%A7%C3%A3o%20Triangular.pdf"
            ><i class="fas fa-angle-double-right"></i> Venda Triangular</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/2-VENDA%20ENTREGA%20FUTURA.pdf"
            ><i class="fas fa-angle-double-right"></i> Venda Entrega Futura</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/3-VENDA%20PRUDUTO%20OUTLET.pdf"
            ><i class="fas fa-angle-double-right"></i> Venda Produto Outlet</a
          >
        </p>
      </div>

      <button class="booking__tablinks" @click="openBook($event, 'parceiros')">
        <i class="fas fa-handshake"></i>
        <span>Parceiros</span>
      </button>

      <div class="booking__tabcontent" id="parceiros">
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/1-termo-parceria.pdf"
            ><i class="fas fa-angle-double-right"></i> Termo Parceria</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/2-Ficha_de_cadastro.docx"
            ><i class="fas fa-angle-double-right"></i> Ficha de Cadastro
            Parceiro</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/3-CADASTRO%20DE%20PARCEIRO.pdf"
            ><i class="fas fa-angle-double-right"></i> Cadastro de Parceiro</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/4-PRIMEIRO%20ACESSO%20A%20PLATAFORMA.pdf"
            ><i class="fas fa-angle-double-right"></i> Primeiro Acesso a
            Plataforma</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/5-CONDI%C3%87%C3%95ES%20PAGAMENTO%20PARCEIROS-Booking.pdf"
            ><i class="fas fa-angle-double-right"></i> Condições de Pagamento
            Parceiros</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/6-ACESSO%20APURA%C3%87%C3%83O%20COMISS%C3%83O.pdf"
            ><i class="fas fa-angle-double-right"></i> Acesso Apuração de
            Comissão</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/Minuta-autorizacao_compensacao.docx"
            ><i class="fas fa-angle-double-right"></i> Minuta para Permuta de
            RT</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/Minuta%20para%20Transfer%C3%AAncia%20RT.docx"
            ><i class="fas fa-angle-double-right"></i> Minuta para Transferência
            RT</a
          >
        </p>
      </div>

      <button
        class="booking__tablinks"
        @click="openBook($event, 'garantiaFabricante')"
      >
        <i class="fas fa-shield-alt"></i>
        <span>Garantia Fabricante</span>
      </button>

      <div class="booking__tabcontent" id="garantiaFabricante">
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/Como%20Localizar%20N%C3%BAmero%20de%20Serie.pdf"
            ><i class="fas fa-angle-double-right"></i> Como Localizar Número de
            Série</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/INCLUS%C3%83O%20DE%20GARANTIA.pdf"
            ><i class="fas fa-angle-double-right"></i> Inclusão de Garantia</a
          >
        </p>
      </div>

      <button
        class="booking__tablinks"
        @click="openBook($event, 'atendimentoComercial')"
      >
        <i class="fas fa-headset"></i>
        <span>Atendimento Sup. Comercial</span>
      </button>

      <div class="booking__tabcontent" id="atendimentoComercial">
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/CARTA%20DE%20DESFAZIMENTO-Venda%20Entrega%20Futura.docx"
            ><i class="fas fa-angle-double-right"></i> Carta de Desfazimento de
            Venda Entrega Futura</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/DECLARA%C3%87%C3%83O%20DE%20COMPRA%20USO%20E%20CONSUMO.docx"
            ><i class="fas fa-angle-double-right"></i> Declaração de Compra para
            Uso e Consumo</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/Manual%20Atendimento%20Suporte%20Comercial.pdf"
            ><i class="fas fa-angle-double-right"></i> Manual Atendimento do
            Suporte Comercial</a
          >
        </p>
        <p>
          <a href="https://atendimento.leveros.com.br/"
            ><i class="fas fa-angle-double-right"></i> Acesso ao GLPI</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/SC-PI01%20%20-%20FINALIZA%C3%87%C3%83O%20E%20CANCELAMENTO%20DE%20PEDIDOS%20BNDES.docx"
            ><i class="fas fa-angle-double-right"></i> CD_PI01 - Finalização e
            Cancelamento de Pedidos BNDES</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/SC-PI02%20%20-%20TRIANGULA%C3%87%C3%83O%20DE%20NOTA%20FISCAL.docx"
            ><i class="fas fa-angle-double-right"></i> CD_PI02 - Triangulação de
            Nota Fiscal</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/SC-PI03%20%20-%20ENTREGA%20FUTURA.docx"
            ><i class="fas fa-angle-double-right"></i> CD_PI03 - Entrega
            Futura</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/SC-PI05%20%20-%20INCLUS%C3%83O%20E%20%20ALTERA%C3%87%C3%83O%20CADASTRO%20PARCEIROS.docx"
            ><i class="fas fa-angle-double-right"></i> CD_PI05 - Inclusão e
            Alteração do Cadastro de Parceiros</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/SC-PI10%20%20-%20APURA%C3%87%C3%83O%20E%20PAGAMENTO%20DE%20COMISS%C3%83O%20PARCEIROS.docx"
            ><i class="fas fa-angle-double-right"></i> CD_PI10 - Apuração e
            Pagamento de Comissão de Parceiros</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/SC-PI11%20%20-%20LIBERA%C3%87%C3%83O%20DE%20ACESSO%20A%20PLATAFORMA%20MAP.docx"
            ><i class="fas fa-angle-double-right"></i> CD_PI11 - Liberação de
            Acesso a Plataforma MAP</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/SC-PI12%20%20-%20ABERTURA%20DE%20CHAMADOS%20GLPI.docx"
            ><i class="fas fa-angle-double-right"></i> CD_PI12 - Abertura de
            Chamados GLPI</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/SC-PI13%20-%20DOA%C3%87%C3%83O%20DE%20PRODUTO%20DE%20REVENDA.docx"
            ><i class="fas fa-angle-double-right"></i> CD_PI13 - Doação de
            Produto de Revenda</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/SC-PI14%20-%20D%C3%9AVIDAS%20SOBRE%20COMISSIONAMENTO%20PARCEIROS.docx"
            ><i class="fas fa-angle-double-right"></i> CD_PI14 - Dúvida Sobre
            Comissionamento de Parceiros</a
          >
        </p>
      </div>

      <button
        class="booking__tablinks"
        @click="openBook($event, 'atendimentoSAI')"
      >
        <i class="fas fa-envelope-open-text"></i>
        <span>Atendimento SAI</span>
      </button>

      <div class="booking__tabcontent" id="atendimentoSAI">
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/1-SAI%20-%20TeD.xlsx"
            ><i class="fas fa-angle-double-right"></i> SAI - T&D</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/2-SAI%20-%20LOG%20ENTREGA%20EM%20ATRASO.xlsx"
            ><i class="fas fa-angle-double-right"></i> SAI - Log Entrega Em
            Atraso</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/3-SAI-CARTA%20DE%20CORRE%C3%87%C3%83O.xlsx"
            ><i class="fas fa-angle-double-right"></i> SAI - Carta de
            Correção</a
          >
        </p>
      </div>

      <button
        class="booking__tablinks"
        @click="openBook($event, 'atendimentoCredito')"
      >
        <i class="fas fa-hand-holding-usd"></i>
        <span>Atendimento Análise de Crédito</span>
      </button>

      <div class="booking__tabcontent" id="atendimentoCredito">
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/INSTRU%C3%87%C3%83O%20DEPOSITO%20IDENTIFICADO.pdf"
            ><i class="fas fa-angle-double-right"></i> Instrução Depósito
            Identificado</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/INSTRU%C3%87%C3%83O%20ESTEIRA%20B2E.pdf"
            ><i class="fas fa-angle-double-right"></i> Instrução Esteira B2E</a
          >
        </p>
        <p>
          <a href="https://app.b2egroup.com.br/"
            ><i class="fas fa-angle-double-right"></i> Acesso B2E</a
          >
        </p>
        <p>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScFr7zelsZm5GEyNnUk3S0go84sKuqvqVIroiAt45mOY7Ob-Q/viewform"
            ><i class="fas fa-angle-double-right"></i> Formulário de Comprovante
            Deposito Identificado</a
          >
        </p>
        <p>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSddArltmO-3_UzfUAZgydzaRzmp1ms3hkEWNaQb09_XvSpPWQ/viewform"
            ><i class="fas fa-angle-double-right"></i> Formulario para Gerar
            Código Depósito Identificado</a
          >
        </p>
        <p>
          <a
            href="https://docs.google.com/spreadsheets/d/1DC6uXP6H4A7tSqKVr0V-GBsAwMe8ZgdXxvoiNKZCVlU/edit#gid=512668357"
            ><i class="fas fa-angle-double-right"></i> Acompanhe Pedidos Com
            Depósito Identificado</a
          >
        </p>
        <p>
          <a
            href="https://atendimento.multiar.com.br/plugins/formcreator/front/formdisplay.php?id=158"
            ><i class="fas fa-angle-double-right"></i> Comprovante de
            Depósito</a
          >
        </p>
        <p>
          <a
            href="https://atendimento.multiar.com.br/plugins/formcreator/front/formdisplay.php?id=155"
            ><i class="fas fa-angle-double-right"></i> Consulta Pagamento de
            Pedido</a
          >
        </p>
        <p>
          <a
            href="https://atendimento.multiar.com.br/plugins/formcreator/front/formdisplay.php?id=186"
            ><i class="fas fa-angle-double-right"></i> Solicitação de Criação
            Financeiro de Atendimento Garantia Estendida</a
          >
        </p>
        <p>
          <a
            href="https://atendimento.multiar.com.br/plugins/formcreator/front/formdisplay.php?id=137"
            ><i class="fas fa-angle-double-right"></i> Prorrogação de
            Vencimentos (Isenção Juros)</a
          >
        </p>
      </div>

      <button class="booking__tablinks" @click="openBook($event, 'outlet')">
        <i class="fas fa-unlink"></i>
        <span>Outlet</span>
      </button>

      <div class="booking__tabcontent" id="outlet">
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/produtos%20outlet.pdf"
            ><i class="fas fa-angle-double-right"></i> Produtos Outlet</a
          >
        </p>
      </div>

      <button
        class="booking__tablinks"
        @click="openBook($event, 'procedimentoLojas')"
      >
        <i class="fas fa-book"></i>
        <span>Procedimentos ADM Lojas</span>
      </button>

      <div class="booking__tabcontent" id="procedimentoLojas">
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/1-Manual-de-Utilizacao-do-PDV.pdf"
            ><i class="fas fa-angle-double-right"></i> Manual de Utilização do
            PDV</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/3-MANUAL%20DE%20FECHAMENTO%20POSCS.pdf"
            ><i class="fas fa-angle-double-right"></i> Manual de Fechamento
            POSCS</a
          >
        </p>
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/2-Fluxo%20e%20Procedimento%20-FECHAMENTO%20DE%20CAIXA%20-%20POSCS.docx"
            ><i class="fas fa-angle-double-right"></i> Fechamento de Caixa</a
          >
        </p>
      </div>

      <button
        class="booking__tablinks"
        @click="openBook($event, 'boletinsInformativos')"
      >
        <i class="fas fa-clipboard-list"></i>
        <span>Boletins Informativos</span>
      </button>

      <div class="booking__tabcontent" id="boletinsInformativos">
        <p>
          <a
            href="https://www.leverosintegra.com.br/plus/Booking/bk-materiais/Boletim%20Informativo-%20at%C3%A9%20a%2010%C2%BA%20Edi%C3%A7%C3%A3o.pdf"
            ><i class="fas fa-angle-double-right"></i> Boletim Informativo- até
            a 10º Edição</a
          >
        </p>
        <p>
          <a href="https://www.aneel.gov.br/tensoes-nominais"
            ><i class="fas fa-angle-double-right"></i> Tensões Nominais por
            Município / Identificar a tensão elétrica TRIFÁSICA</a
          >
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    openBook(event, value) {
      let i, tablinks, tabcontent;

      tabcontent = document.getElementsByClassName("booking__tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }

      tablinks = document.getElementsByClassName("booking__tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      document.getElementById(value).style.display = "block";
      event.currentTarget.className += " active";
    },
  },
};
</script>


<style lang="scss" scoped>
.booking {
  max-width: 95%;
  margin: 0 auto;
  padding-top: 20px;

  @media (min-width: 441px) {
    max-width: 75%;
  }

  h2 {
    color: var(--standardGreen);
    padding: 40px 0 20px 0;
    font-size: 1.4rem;
  }

  &__tab {
    display: flex;
    flex-direction: column;
  }

  &__tablinks {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: var(--standardGreen);
    color: var(--customWhite);
    padding: 15px;
    margin: 10px 0;
    outline: none;

    i {
      font-size: 2.5rem;
      padding-bottom: 15px;
    }

    span {
      font-weight: bold;
    }
  }

  &__tabcontent {
    display: none;
    background: var(--customGray-100);
    padding: 20px;

    p {
      line-height: 1.9;
      a {
        text-decoration: none;
        color: #179baa;

        &:hover {
          color: #096f7a;
        }
      }
    }
  }
}
</style>